// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NavBar-root{background:#000850;height:60px;border-radius:0 0 7px 7px;box-shadow:3.86979px 0px 11.6094px #b9bbcf;position:absolute;top:0;width:100vw;z-index:2}.NavBar-CompanyLogo{height:40px;display:flex;align-items:center;margin-top:8px;margin-bottom:8px;margin-left:48px}", ""]);
// Exports
module.exports = exports;
